export default function constructMetaObject(post, type = 'website', defaultMeta = {}) {
	const meta = {}

	meta.pageTitle = (post.seo_enabled && post.seo_title) ? post.seo_title : post.title
	meta.metaDescription = (post.seo_enabled && post.meta_description) ? post.meta_description : null
	meta.ogTitle = (post.og_enabled && post.og_title) ? post.og_title : (post.seo_enabled ? post.seo_title : post.title)
	meta.ogType = type === 'article' ? 'article' : 'website'
	meta.ogDescription = (post.og_enabled && post.og_description) ? post.og_description : (post.seo_enabled ? post.meta_description : null)
	meta.ogImage = (post.og_enabled && post.og_image && post.og_image.sizes['bandara_social-share-large']) ? post.og_image.sizes['bandara_social-share-large'] : (post.featured_image ? post.featured_image.sizes.bandara_large : null)

	return meta
}



// WEBPACK FOOTER //
// ./src/api/util/constructMetaObject.js